// import React, { useCallback, useEffect, useState } from "react";
// import { OnboardPageProps } from "../../models/OnboardPageProps";
// import { UserAuth } from "../../context/AuthContext";
// import { get, ref, update, set, remove } from "firebase/database";
// import { database } from "../../firebase";
// import { Paper, Stack, TextField, Typography, Slider, FormControl, InputLabel, Select, MenuItem, Grid, IconButton } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import CheckIcon from "@mui/icons-material/Check";
// import DeleteIcon from "@mui/icons-material/Delete";

// export interface MentalHealthModel {
//   title: string;
//   stressLevel: number;
//   happinessScore: number;
//   mentalCondition: string;
//   additionalNotes: string;
//   demographicSize: number | "";
// }

// const MentalHealthCard = ({ healthProp, deleteCallback, editModeProp }: { healthProp: MentalHealthModel, deleteCallback: () => void, editModeProp?: boolean }) => {
//   const auth = UserAuth();
//   const [editMode, setEditMode] = useState(editModeProp || false);
//   const [health, setHealth] = useState<MentalHealthModel>(healthProp);

//   const handleChange = (field: keyof MentalHealthModel, value: any) => {
//     setHealth({ ...health, [field]: value });
//   };

//   const saveChanges = () => {
//     if (auth?.user && health.title.trim() !== "") {
//       const healthRef = ref(database, `users/${auth.user.id}/mentalHealth/${health.title}`);
//       get(healthRef).then((snapshot) => {
//         if (snapshot.exists()) {
//           update(healthRef, health);
//         } else {
//           set(healthRef, health);
//         }
//       });
//     }
//     setEditMode(false);
//   };

//   return (
//     <Paper style={{ padding: "1.5rem", borderRadius: "5px", backgroundColor: "#F3F5EA", border: "1px solid #ddd", height: "100%", display: "flex", flexDirection: "column" }}>
//       <Stack direction={"row"} justifyContent={"space-between"} alignItems="flex-start" mb={3}>
//         {editMode ? (
//           <TextField variant="outlined" label="Group Title (e.g. Remote Workers)" size="small" value={health.title} onChange={(e) => handleChange("title", e.target.value)} />
//         ) : (
//           <Typography variant="h5" fontWeight="bold">{health.title || "Untitled Group"}</Typography>
//         )}
//         <Stack direction={"row"} spacing={1}>
//           {editMode ? (
//             <>
//               <IconButton onClick={saveChanges} color="primary"><CheckIcon /></IconButton>
//               <IconButton onClick={deleteCallback} color="error"><DeleteIcon /></IconButton>
//             </>
//           ) : (
//             <IconButton onClick={() => setEditMode(true)} color="primary"><EditIcon /></IconButton>
//           )}
//         </Stack>
//       </Stack>

//       <Stack spacing={3} sx={{ flexGrow: 1 }}>
//         {editMode ? (
//           <TextField variant="outlined" fullWidth size="small" type="number" label="Total People in this Demographic" value={health.demographicSize || ""} onChange={(e) => handleChange("demographicSize", e.target.value === "" ? "" : Number(e.target.value))} InputProps={{ inputProps: { min: 0 } }} />
//         ) : (
//           <Typography variant="subtitle2">Demographic Size: {health.demographicSize || "Not specified"}</Typography>
//         )}

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Stress Level (1-10): {health.stressLevel}</Typography>
//           <Slider disabled={!editMode} value={health.stressLevel} onChange={(e, val) => handleChange("stressLevel", val)} step={1} marks min={1} max={10} color="error" />
//         </div>

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Happiness Score (1-10): {health.happinessScore}</Typography>
//           <Slider disabled={!editMode} value={health.happinessScore} onChange={(e, val) => handleChange("happinessScore", val)} step={1} marks min={1} max={10} color="primary" />
//         </div>

//         <FormControl fullWidth size="small" disabled={!editMode}>
//           <InputLabel>Diagnosed Mental Condition</InputLabel>
//           <Select value={health.mentalCondition} label="Diagnosed Mental Condition" onChange={(e) => handleChange("mentalCondition", e.target.value)}>
//             <MenuItem value="None">None</MenuItem>
//             <MenuItem value="Anxiety">Anxiety</MenuItem>
//             <MenuItem value="Depression">Depression</MenuItem>
//             <MenuItem value="Other">Other</MenuItem>
//           </Select>
//         </FormControl>

//         {editMode ? (
//           <TextField label="Additional Notes (Optional)" multiline rows={3} variant="outlined" fullWidth value={health.additionalNotes} onChange={(e) => handleChange("additionalNotes", e.target.value)} />
//         ) : (
//           <Typography variant="body2"><strong>Notes:</strong> {health.additionalNotes || "None"}</Typography>
//         )}
//       </Stack>
//     </Paper>
//   );
// };

// const ReviewForm = (props: OnboardPageProps) => {
//   const auth = UserAuth();
//   const [healthRecords, setHealthRecords] = useState<{ id: string, data: MentalHealthModel, editMode: boolean }[]>([]);

//   const fetchRecords = useCallback(async () => {
//     if (auth?.user) {
//       const healthRef = ref(database, `users/${auth.user.id}/mentalHealth`);
//       const snapshot = await get(healthRef);
//       const data = snapshot.val();
//       if (data) {
//         const parsedArray = Object.entries(data)
//           .filter(([_, val]) => typeof val === 'object' && val !== null && 'title' in (val as any))
//           .map(([id, val]) => ({ id, data: val as MentalHealthModel, editMode: false }));
//         setHealthRecords(parsedArray);
//       }
//     }
//   }, [auth?.user]);

//   useEffect(() => { fetchRecords(); }, [fetchRecords]);

//   const saveData = useCallback(() => {
//     console.log("Mental health saved on per-card basis.");
//   }, []);

//   useEffect(() => { props.registerSave(saveData); }, [props, props.registerSave, saveData]);

//   const handleAdd = () => {
//     setHealthRecords([...healthRecords, {
//       id: Date.now().toString(),
//       data: { title: "", stressLevel: 5, happinessScore: 5, mentalCondition: "None", additionalNotes: "", demographicSize: "" },
//       editMode: true
//     }]);
//   };

//   const handleDelete = (idToRemove: string, titleToRemove: string) => {
//     setHealthRecords((prev) => prev.filter((item) => item.id !== idToRemove));
//     if (auth?.user && titleToRemove) {
//       remove(ref(database, `users/${auth.user.id}/mentalHealth/${titleToRemove}`));
//     }
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
//       <Typography variant="h4" sx={{ marginTop: "1rem", textAlign: "center" }}>Mental & Emotional Indicators</Typography>
//       <Stack direction="row" justifyContent="flex-end" width="100%" mb={2}>
//         <IconButton onClick={handleAdd} color="primary" size="large"><AddIcon fontSize="inherit" /></IconButton>
//       </Stack>
//       <Grid container spacing={3}>
//         {healthRecords.map((item) => (
//           <Grid item xs={12} md={6} key={item.id}>
//             <MentalHealthCard healthProp={item.data} deleteCallback={() => handleDelete(item.id, item.data.title)} editModeProp={item.editMode} />
//           </Grid>
//         ))}
//       </Grid>
//     </div>
//   );
// };

// export default ReviewForm;


// import React, { useCallback, useEffect, useState } from "react";
// import { OnboardPageProps } from "../../models/OnboardPageProps";
// import { UserAuth } from "../../context/AuthContext";
// import { get, ref, set, remove } from "firebase/database";
// import { database } from "../../firebase";
// import { Paper, Stack, TextField, Typography, Slider, FormControl, InputLabel, Select, MenuItem, Grid, Button } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteIcon from "@mui/icons-material/Delete";

// export interface MentalHealthModel {
//   title: string;
//   stressLevel: number;
//   happinessScore: number;
//   mentalCondition: string;
//   additionalNotes: string;
//   demographicSize: number | "";
// }

// // FIX: Added updateCallback to props
// const MentalHealthCard = ({ healthId, healthProp, deleteCallback, updateCallback }: { healthId: string, healthProp: MentalHealthModel, deleteCallback: () => void, updateCallback: (data: MentalHealthModel) => void }) => {
//   const auth = UserAuth();
//   const [health, setHealth] = useState<MentalHealthModel>(healthProp);

//   const autoSaveToFirebase = (dataToSave: MentalHealthModel) => {
//     if (auth?.user) {
//       set(ref(database, `users/${auth.user.id}/mentalHealth/${healthId}`), dataToSave);
//     }
//   };

//   const handleChange = (field: keyof MentalHealthModel, value: any) => {
//     const updatedHealth = { ...health, [field]: value };
//     setHealth(updatedHealth);
//     autoSaveToFirebase(updatedHealth);
//     updateCallback(updatedHealth); // FIX: Send data to parent
//   };

//   const handleTextChange = (field: keyof MentalHealthModel, value: any) => {
//     const updatedHealth = { ...health, [field]: value };
//     setHealth(updatedHealth);
//     updateCallback(updatedHealth); // FIX: Send data to parent
//   };

//   const handleBlur = () => {
//     autoSaveToFirebase(health);
//   };

//   return (
//     <Paper style={{ padding: "1.5rem", borderRadius: "8px", backgroundColor: "#F3F5EA", border: "1px solid #ddd", height: "100%", display: "flex", flexDirection: "column" }}>
//       <Stack spacing={3} sx={{ flexGrow: 1 }}>
//         <TextField
//           variant="standard"
//           placeholder="Group Title (e.g. Remote Workers)"
//           value={health.title}
//           onChange={(e) => handleTextChange("title", e.target.value)}
//           onBlur={handleBlur}
//           InputProps={{ style: { fontSize: '1.5rem', fontWeight: 'bold' } }}
//         />

//         <TextField
//           variant="outlined"
//           fullWidth
//           size="small"
//           type="number"
//           label="Target Demographic (Number of people)"
//           value={health.demographicSize || ""}
//           onChange={(e) => handleTextChange("demographicSize", e.target.value === "" ? "" : Number(e.target.value))}
//           onBlur={handleBlur}
//           InputProps={{ inputProps: { min: 0 } }}
//         />

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Stress Level (1-10): {health.stressLevel}</Typography>
//           <Slider value={health.stressLevel} onChange={(e, val) => handleChange("stressLevel", val)} step={1} marks min={1} max={10} color="error" />
//         </div>

//         <div>
//           <Typography variant="subtitle2" gutterBottom>Happiness Score (1-10): {health.happinessScore}</Typography>
//           <Slider value={health.happinessScore} onChange={(e, val) => handleChange("happinessScore", val)} step={1} marks min={1} max={10} color="primary" />
//         </div>

//         <FormControl fullWidth size="small">
//           <InputLabel>Diagnosed Mental Condition</InputLabel>
//           <Select value={health.mentalCondition} label="Diagnosed Mental Condition" onChange={(e) => handleChange("mentalCondition", e.target.value)}>
//             <MenuItem value="None">None</MenuItem>
//             <MenuItem value="Anxiety">Anxiety</MenuItem>
//             <MenuItem value="Depression">Depression</MenuItem>
//             <MenuItem value="Other">Other</MenuItem>
//           </Select>
//         </FormControl>

//         <TextField
//           label="Additional Notes (Optional)"
//           multiline
//           rows={3}
//           variant="outlined"
//           fullWidth
//           value={health.additionalNotes}
//           onChange={(e) => handleTextChange("additionalNotes", e.target.value)}
//           onBlur={handleBlur}
//         />
//       </Stack>

//       <Stack direction="row" justifyContent="flex-end" mt={3}>
//         <Button size="small" color="error" startIcon={<DeleteIcon />} onClick={deleteCallback}>
//           Delete
//         </Button>
//       </Stack>
//     </Paper>
//   );
// };

// const ReviewForm = (props: OnboardPageProps) => {
//   const auth = UserAuth();
//   const [healthRecords, setHealthRecords] = useState<{ id: string, data: MentalHealthModel }[]>([]);

//   const fetchRecords = useCallback(async () => {
//     if (auth?.user) {
//       const healthRef = ref(database, `users/${auth.user.id}/mentalHealth`);
//       const snapshot = await get(healthRef);
//       if (snapshot.exists()) {
//         const parsedArray = Object.entries(snapshot.val()).map(([id, val]) => ({
//           id, data: val as MentalHealthModel
//         }));
//         setHealthRecords(parsedArray);
//       }
//     }
//   }, [auth?.user]);

//   useEffect(() => { fetchRecords(); }, [fetchRecords]);

//   const saveData = useCallback(() => {
//     return healthRecords.map(h => h.data);
//   }, [healthRecords]);

//   useEffect(() => { props.registerSave(saveData); }, [props, saveData]);

//   const handleAdd = () => {
//     const newId = Date.now().toString();
//     const newRecord: MentalHealthModel = { title: "", stressLevel: 5, happinessScore: 5, mentalCondition: "None", additionalNotes: "", demographicSize: "" };

//     setHealthRecords([...healthRecords, { id: newId, data: newRecord }]);

//     if (auth?.user) {
//       set(ref(database, `users/${auth.user.id}/mentalHealth/${newId}`), newRecord);
//     }
//   };

//   const handleDelete = (idToRemove: string) => {
//     setHealthRecords((prev) => prev.filter((item) => item.id !== idToRemove));
//     if (auth?.user) {
//       remove(ref(database, `users/${auth.user.id}/mentalHealth/${idToRemove}`));
//     }
//   };

//   // FIX: Master update function for the array
//   const handleUpdate = (idToUpdate: string, updatedData: MentalHealthModel) => {
//     setHealthRecords((prev) => prev.map(item => item.id === idToUpdate ? { ...item, data: updatedData } : item));
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
//       <Typography variant="h4" sx={{ marginTop: "1rem", textAlign: "center" }}>Mental & Emotional Indicators</Typography>
//       <Stack direction="row" justifyContent="flex-end" width="100%" mb={2}>
//         <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={handleAdd}>Add Demographic</Button>
//       </Stack>
//       <Grid container spacing={3}>
//         {healthRecords.map((item) => (
//           <Grid item xs={12} md={6} key={item.id}>
//             <MentalHealthCard
//               healthId={item.id}
//               healthProp={item.data}
//               deleteCallback={() => handleDelete(item.id)}
//               updateCallback={(data) => handleUpdate(item.id, data)} // FIX: Hooked up!
//             />
//           </Grid>
//         ))}
//       </Grid>
//     </div>
//   );
// };

// export default ReviewForm;



//15-04
import React, { useCallback, useEffect, useState } from "react";
// REMOVED: import { UserAuth } from "../../context/AuthContext";
// REMOVED: import { get, ref, set, remove } from "firebase/database";
// REMOVED: import { database } from "../../firebase";
import { OnboardPageProps } from "../../models/OnboardPageProps";
import { Paper, Stack, TextField, Typography, Slider, FormControl, InputLabel, Select, MenuItem, Grid, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export interface MentalHealthModel {
  title: string;
  stressLevel: number;
  happinessScore: number;
  mentalCondition: string;
  additionalNotes: string;
  demographicSize: number | "";
}

const MentalHealthCard = ({
  healthId,
  healthProp,
  deleteCallback,
  updateCallback
}: {
  healthId: string,
  healthProp: MentalHealthModel,
  deleteCallback: () => void,
  updateCallback: (data: MentalHealthModel) => void
}) => {
  const [health, setHealth] = useState<MentalHealthModel>(healthProp);

  const handleChange = (field: keyof MentalHealthModel, value: any) => {
    const updatedHealth = { ...health, [field]: value };
    setHealth(updatedHealth);
    updateCallback(updatedHealth);
  };

  const handleTextChange = (field: keyof MentalHealthModel, value: any) => {
    const updatedHealth = { ...health, [field]: value };
    setHealth(updatedHealth);
    updateCallback(updatedHealth);
  };

  return (
    <Paper style={{ padding: "1.5rem", borderRadius: "8px", backgroundColor: "#F3F5EA", border: "1px solid #ddd", height: "100%", display: "flex", flexDirection: "column" }}>
      <Stack spacing={3} sx={{ flexGrow: 1 }}>
        <TextField
          variant="standard"
          placeholder="Group Title (e.g. Remote Workers)"
          value={health.title}
          onChange={(e) => handleTextChange("title", e.target.value)}
          // REMOVED: onBlur
          InputProps={{ style: { fontSize: '1.5rem', fontWeight: 'bold' } }}
        />

        <TextField
          variant="outlined"
          fullWidth
          size="small"
          type="number"
          label="Target Demographic (Number of people)"
          value={health.demographicSize || ""}
          onChange={(e) => handleTextChange("demographicSize", e.target.value === "" ? "" : Number(e.target.value))}
          InputProps={{ inputProps: { min: 0 } }}
        />

        <div>
          <Typography variant="subtitle2" gutterBottom>Stress Level (1-10): {health.stressLevel}</Typography>
          <Slider value={health.stressLevel} onChange={(e, val) => handleChange("stressLevel", val)} step={1} marks min={1} max={10} color="error" />
        </div>

        <div>
          <Typography variant="subtitle2" gutterBottom>Happiness Score (1-10): {health.happinessScore}</Typography>
          <Slider value={health.happinessScore} onChange={(e, val) => handleChange("happinessScore", val)} step={1} marks min={1} max={10} color="primary" />
        </div>

        <FormControl fullWidth size="small">
          <InputLabel>Diagnosed Mental Condition</InputLabel>
          <Select value={health.mentalCondition} label="Diagnosed Mental Condition" onChange={(e) => handleChange("mentalCondition", e.target.value)}>
            <MenuItem value="None">None</MenuItem>
            <MenuItem value="Anxiety">Anxiety</MenuItem>
            <MenuItem value="Depression">Depression</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Additional Notes (Optional)"
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          value={health.additionalNotes}
          onChange={(e) => handleTextChange("additionalNotes", e.target.value)}
          // REMOVED: onBlur
        />
      </Stack>

      <Stack direction="row" justifyContent="flex-end" mt={3}>
        <Button size="small" color="error" startIcon={<DeleteIcon />} onClick={deleteCallback}>
          Delete
        </Button>
      </Stack>
    </Paper>
  );
};

const ReviewForm = (props: OnboardPageProps) => {
  // Initialize as empty array (no fetching from Firebase)
  const [healthRecords, setHealthRecords] = useState<{ id: string, data: MentalHealthModel }[]>([]);

  // Pass current local state back to the parent
  const saveData = useCallback(() => {
    return healthRecords.map(h => h.data);
  }, [healthRecords]);

  useEffect(() => { props.registerSave(saveData); }, [props, saveData]);

  const handleAdd = () => {
    const newId = Date.now().toString(); // Local temp ID
    const newRecord: MentalHealthModel = {
      title: "",
      stressLevel: 5,
      happinessScore: 5,
      mentalCondition: "None",
      additionalNotes: "",
      demographicSize: ""
    };

    setHealthRecords([...healthRecords, { id: newId, data: newRecord }]);
  };

  const handleDelete = (idToRemove: string) => {
    setHealthRecords((prev) => prev.filter((item) => item.id !== idToRemove));
  };

  const handleUpdate = (idToUpdate: string, updatedData: MentalHealthModel) => {
    setHealthRecords((prev) => prev.map(item => item.id === idToUpdate ? { ...item, data: updatedData } : item));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Typography variant="h4" sx={{ marginTop: "1rem", textAlign: "center" }}>Mental & Emotional Indicators</Typography>
      <Stack direction="row" justifyContent="flex-end" width="100%" mb={2}>
        <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={handleAdd}>Add Demographic</Button>
      </Stack>
      <Grid container spacing={3}>
        {healthRecords.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <MentalHealthCard
              healthId={item.id}
              healthProp={item.data}
              deleteCallback={() => handleDelete(item.id)}
              updateCallback={(data) => handleUpdate(item.id, data)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ReviewForm;
